import Image from "next/image";
import Link from "next/link";

export default function Copyright({ locale }: { locale: string }) {
  const isAr = locale === "ar";

  return (
    <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] md:text-xs text-white/40 uppercase tracking-widest font-medium">
      <p className="text-center md:text-start">
        © {new Date().getFullYear()}{" "}
        <span className="text-white/60">
          {isAr ? "الدولية للصناعات المعدنية" : "AL DAWLIA METAL INDUSTRIES"}
        </span>
        . {isAr ? "جميع الحقوق محفوظة" : "All rights reserved"}
      </p>

      <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
        <Link
          href="/privacy"
          className="hover:text-brand-red transition-colors"
        >
          {isAr ? "سياسة الخصوصية" : "Privacy Policy"}
        </Link>
        <Link href="/terms" className="hover:text-brand-red transition-colors">
          {isAr ? "الشروط والأحكام" : "Terms of Service"}
        </Link>

        <span className="hidden md:inline text-white/20">|</span>

        <p className="lowercase opacity-80">
          {isAr ? "تم التطوير بواسطة" : "Crafted by"}{" "}
          <Link
            href="https://novi-ms.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors underline underline-offset-4"
          >
            <Image
              src={`/footer.webp`}
              alt="Developed by NoVi"
              width={30}
              height={30}
              className="inline-block ml-2"
            />
          </Link>
        </p>
      </div>
    </div>
  );
}
